import {List, Map, OrderedMap} from 'immutable';

import {getCookie} from 'cookie-utils';

import * as DisplayMode from 'constants/DisplayMode';
import * as ConnectionStatus from 'constants/ConnectionStatus';
import * as RepositoryState from 'constants/RepositoryState';

import entitiesReducer from 'shared/reducers/entities/entitiesReducer';
import displayModeReducer from './displayModeReducer';
import connectionStatusReducer from './connectionStatusReducer';
import localeReducer from './localeReducer';
import couponReducer from './coupon/couponReducer';
import betHistoryReducer from './betHistory/betHistoryReducer';
import bettingModeReducer from './bettingModeReducer';
import menuReducer from './menu/menuReducer';
import newsReducer from './newsReducer';
import messagesReducer from './messagesReducer';
import userSelectionReducer from './userSelectionReducer';
import userSelectionStorableReducer from './userSelectionStorableReducer';
import bettingAvailableReducer from './bettingAvailableReducer';
import streamReducer from './streamReducer';
import betradarReducer from './betradarReducer';
import jacktopGamesReducer from './jacktopGamesReducer'
import gamblerInfoReducer from './GamblerInfoReducer'

const providedInitialState = window.__INITIAL_STATE__;
const languageId = Number(localStorage.getItem('languageId') || providedInitialState.languageId || parseInt(getCookie('languageId')) || 1);

const initialState = Map({
    connectionStatus: ConnectionStatus.CONNECTED,
    languageId,
    menu: new Map({
        sports: new Map(),
        leagues: new Map()
    }),
    preMatch: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        groups: new Map(),
        outcomes: new Map(),
        rates: new Map(),
        valid: true
    }),
    live: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        scores: new Map(),
        groups: new Map(),
        outcomes: new Map(),
        rates: new Map(),
        valid: true,
        state: RepositoryState.NOT_INITED,
        showLineNumbers: false,
        version: 0
    }),
    stakeOfTheDay: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        scores: new Map(),
        groups: new Map(),
        outcomes: new Map(),
        rates: new Map(),
        valid: true
    }),
    popularMatches: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        scores: new Map(),
        groups: new Map(),
        outcomes: new Map(),
        rates: new Map(),
        valid: true
    }),
    timetable: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        valid: true,
        state: RepositoryState.NOT_INITED,
        version: 0
    }),
    displayMode: {
        type: DisplayMode.ALL
    },
    bettingMode: new Map(),
    coupon: new Map({
        betSlips: new OrderedMap(),
        betTypes: new List(),
        currentBetTypeIndex: undefined,
        currentBetTypeSelected: false,
        state: undefined,
        betSlipAmounts: new Map(),
        amount: 0,
        freebet: undefined,
        isFreebet: new Map()
    }),
    betHistory: new Map(),
    news: [],
    messages: new Map({
        newMessagesCount: undefined
    }),
    userGridSelection: new Map({
        main: new Map({
            sportsExpanded: new List()
        }),
        preMatch: new Map({
            sportsExpanded: new List(),
            leaguesExpanded: new List(),
            matchesExpanded: new List(),
            lastShown: null
        }),
        live: new Map({
            sportsExpanded: new List(),
            leaguesExpanded: new List(),
            matchesExpanded: new List(),
            lastShown: null
        })
    }),
    userGridStorable: false,
    bettingAvailable: true,
    stream: {
        openStream: false,
        matchId: undefined,
        src: undefined
    },
    jacktopGames: {
        fetching: false,
        token: null,
        error: null,
    },
    gamblerInfo: {
        fetching: false,
        data: null,
        error: null,
    }
});

export default function applicationReducer(state, action) {
    if (state === undefined) {
        return initialState;
    }

    state = state.update('live', (s) => entitiesReducer(s, action, 'live'));
    state = state.update('menu', (s) => entitiesReducer(s, action, 'menu'));
    state = state.update('preMatch', (s) => entitiesReducer(s, action, 'preMatch'));
    state = state.update('popularMatches', (s) => entitiesReducer(s, action, 'popularMatches'));
    state = state.update('stakeOfTheDay', (s) => entitiesReducer(s, action, 'stakeOfTheDay'));
    state = state.update('timetable', (s) => entitiesReducer(s, action, 'timetable'));

    state = state.update('menu', (e) => menuReducer(e, action));
    state = state.update('displayMode', (dm) => displayModeReducer(dm, action));
    state = state.update('connectionStatus', (cs) => connectionStatusReducer(cs, action));
    state = state.update('languageId', (l) => localeReducer(l, action));
    state = state.update('betHistory', (bh) => betHistoryReducer(bh, action));
    state = state.update('bettingMode', (bm) => bettingModeReducer(bm, action));

    state = state.update('coupon', (c) => couponReducer(c, action));
    state = state.update('news', (n) => newsReducer(n, action));
    state = state.update('messages', (m) => messagesReducer(m, action));
    state = state.update('userGridSelection', (us) => userSelectionReducer(us, action));
    state = state.update('userGridStorable', (ugs) => userSelectionStorableReducer(ugs, action));
    state = state.update('bettingAvailable', (ba) => bettingAvailableReducer(ba, action));
    state = state.update('stream', (sr) => streamReducer(sr, action));
    state = state.update('betradar', (s) => betradarReducer(s, action));
    state = state.update('jacktopGames', (jg) => jacktopGamesReducer(jg, action));
    state = state.update('gamblerInfo', (gi) => gamblerInfoReducer(gi, action));

    return state;
}


// WEBPACK FOOTER //
// ./js/sport-betting/reducers/applicationReducer.js